<template>
  <Loading v-if="loading" />
  <div class="modules">
    <div class="module-block">
      <div
        class="container"
        v-for="(item, index) of localModules"
        :key="item.id ?? index"
      >
        <div class="module">
          <div class="moduleId">
            <p class="id">{{ item.id ?? index }}</p>
          </div>
          <div class="moduleInfo">
            <div
              v-for="locker in item.lockers"
              :key="locker.position"
              :class="{
                locker: true,
                [boxesNames[locker.type]?.value]: true,
                fridge: locker.fridge,
                active: activeLocker === `${item.id} - ${locker.position}`,
                'locker-state-disabled': locker.state === 'disabled'
              }"
              @click="
                locker.state !== 'disabled' &&
                  chooseLocker(
                    item.position,
                    item.id,
                    locker.position,
                    boxesNames[locker.type],
                    locker.temperature
                  )
              "
              :data-testid="'moduleInfo' + locker.position"
            >
              <div class="locker-name">
                <img
                  class="statusImg"
                  :src="
                    require(`@/assets/icons/${getStatusReservations(
                      locker,
                      allStatus
                    )}.svg`)
                  "
                  alt="status"
                />
                <span>
                  {{ item.id }} - {{ locker.position }}
                  {{ $t(boxesNames[locker?.type]?.label) }}
                </span>
              </div>
              <Checkbox
                v-if="multipleLockers === true"
                class="checkbox-lockerId"
                :name="`${item.id}-${locker.position}`"
                :value="
                  selectedLockers.includes(`${item.id}-${locker.position}`)
                "
                :disabled="disabledLocker() || locker.state === 'disabled'"
                @change="handleCheckbox"
              />
              <img
                src="@/assets/icons/Fridge.svg"
                alt=""
                v-if="locker.fridge"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="createReservation" v-if="multipleLockers">
    <div class="createReservation__selectedLockers">
      <p>{{ selectedLockers.length }} {{ $t('lockersSelected') }}</p>
    </div>
    <Button
      v-if="false"
      class="createReservation__button"
      :variant="selectedLockers.length ? 'filled' : 'disabled'"
      :title="$t('createReservation')"
      :disabled="!selectedLockers.length === true"
      @click="closeModalReservation()"
    />
    <Button
      class="assignReservation-button"
      :variant="selectedLockers.length ? 'filled' : 'disabledLong'"
      :title="$t('assignReservation')"
      :disabled="!selectedLockers.length === true"
      @click="assignReservation"
    />
  </div>
  <ReserveLocker
    v-if="showModalReserveLocker"
    @closeModal="showModalReserveLocker = false"
    :selectedLockers="selectedLockers"
    :activePickupBox="activePickupBox"
  />
  <ChooseDelivery
    v-if="showModalChooseDelivery"
    :showModalChooseDelivery="showModalChooseDelivery"
    :activeBoxId="activeBoxId"
    :selectedLockers="selectedLockers"
    @closeModal="showModalChooseDelivery = false"
  />
  <InfoLocker
    v-if="!multipleLockers && showOrder"
    :order="order"
    :activeLocker="activeLocker"
    :disableLocker="disableLocker"
    :lockerData="lockerData"
    :activePickupBox="activePickupBox"
    @updateLockerDataCallback="updateLockerDataCallback"
  />
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';
import { mapActions } from 'vuex';

import Loading from '@/views/Loading.vue';

import InfoLocker from './InfoLocker/InfoLocker.vue';
import ReserveLocker from '@/duplicatePages/ReserveLocker/ReserveLocker.vue';
import ChooseDelivery from './ChooseDelivery/ChooseDelivery.vue';

import { boxesNames } from './configs';
import { allStatus } from '@/constants';
import { Locker, Module } from '@/store/modules/pharmacy/types';
import { InputFileEvent } from '@/types';

@Options({
  name: 'Modules',
  emits: ['multipleLockersFalse'],
  props: ['modules', 'activePickupBox', 'multipleLockers'],
  components: {
    Loading,
    InfoLocker,
    ReserveLocker,
    ChooseDelivery
  },
  data() {
    return {
      formData: {
        position: null
      },
      localModules: [],
      lockerData: null,
      activeLocker: null,
      disableLocker: null,
      selectedLockers: [],
      activeBoxId: '',
      selectedLocker: null,
      lockerId: false,
      order: null,
      boxesNames,
      allStatus,
      loading: false,
      showOrder: false,
      showModalReserveLocker: false,
      showModalChooseDelivery: false
    };
  },
  methods: {
    ...mapActions('pharmacy', ['updatePickupBox']),
    getStatusReservations(locker: Locker, allStatus: Record<string, string>) {
      if (locker.order?.deliveryStatus) {
        return allStatus[locker.order.deliveryStatus] || 'reserved';
      }

      if (locker.status) {
        return allStatus[locker.status] || 'free';
      }

      return 'free';
    },
    updateLockerDataCallback() {
      this.chooseLocker(...this.selectedLocker);
    },
    chooseLocker(
      originalPosition: number,
      currentIndex: number,
      lockerNumber: number,
      size: string,
      temperature: number
    ) {
      this.showOrder = true;

      const selectedModule = this.modules.find(
        (m: Module) => m.position === originalPosition
      );

      if (selectedModule?.lockers[lockerNumber]) {
        this.order = {
          size,
          status: 'free',
          temperature,
          ...selectedModule.lockers[lockerNumber].order
        };

        if (selectedModule.lockers[lockerNumber].status === 'inactive') {
          this.order = {
            size,
            status: 'inactive',
            temperature,
            ...selectedModule.lockers[lockerNumber].order
          };
        }

        if (this.order.deliveryStatus === 'removed') {
          this.order = {
            size,
            status: 'free',
            temperature
          };
        } else {
          this.order;
        }

        this.lockerData = {
          ...selectedModule.lockers[lockerNumber]
        };
      }

      this.activeLocker = `${currentIndex}-${lockerNumber}`;
      this.disableLocker = `${currentIndex}-${lockerNumber}`;

      this.selectedLocker = [
        originalPosition,
        currentIndex,
        lockerNumber,
        size,
        temperature
      ];
    },
    handleCheckbox(e: InputFileEvent) {
      if (this.selectedLockers.indexOf(e.target.name) != -1) {
        this.selectedLockers.splice(
          this.selectedLockers.indexOf(e.target.name),
          1
        );
      } else {
        this.selectedLockers.push(e.target.name);
      }
    },
    disabledLocker() {
      if (this.lockerData?.order || this.lockerData?.status === 'inactive') {
        return true;
      } else {
        return false;
      }
    },
    closeModalReservation() {
      this.showModalReserveLocker = true;
      this.$emit('multipleLockersFalse');
    },
    assignReservation() {
      this.activeBoxId = this.activePickupBox.id;
      this.showModalChooseDelivery = true;
    }
  },
  watch: {
    modules: {
      immediate: true,
      deep: true,
      handler(val) {
        if (val) {
          this.localModules = [...val].sort((a, b) => a.position - b.position);

          if (this.modules) {
            if (this.lockerData) {
              this.updateLockerDataCallback();
            }
          }
        }
      }
    },
    activePickupBox() {
      if (this.activePickupBox) {
        this.selectedLockers = [];

        if (this.activePickupBox.id) {
          this.showOrder = false;
        }
      }
    },
    showOrder() {
      if (!this.showOrder) {
        this.selectedLockers = [];
      }
    }
  }
})
export default class Modules extends Vue {}
</script>

<style lang="scss" scoped>
.modulesChangedPosition {
  margin: 0 24px;
}

.modules {
  padding: 5px 24px 24px 24px;
}

.createReservation {
  width: 100%;
  margin-right: 24px;
  .createReservation__selectedLockers {
    display: flex;
    align-items: center;
    border: 1px solid $border;
    border-radius: 8px;
    padding: 24px;
    margin-bottom: 24px;
  }
  .createReservation__button {
    width: 170px;
    margin-right: 10px;
    margin-bottom: 10px;
  }
  .assignReservation-button {
    width: 270px;
  }
}

.module-block {
  display: flex;
  min-height: 610px;
  width: max-content;
  height: max-content;
  background-color: $light-grey;
  border: 1px solid $border;
  border-radius: 8px;
  .container {
    border-radius: 8px;
    background-color: $light-grey;
    &::before {
      position: absolute;
      content: '';
      top: 9px;
      right: 0px;
      width: 1px;
      height: 97%;
      background-color: $border;
    }
    &:last-child::before {
      content: none;
    }
    &:hover {
      cursor: auto;
    }
    .module {
      position: relative;
      width: 135px;
      margin: 10px;
      background-color: $light-grey;
      .moduleId {
        .id {
          color: $columnMainTitle;
          text-align: center;
          font-size: $fourteenSize;
          padding-bottom: 12px;
          background-color: $light-grey;
        }
      }
      .moduleInfo {
        background-color: $light-grey;
        .locker {
          display: flex;
          align-items: center;
          justify-content: space-between;
          width: 100%;
          border: 1px solid $border;
          text-align: center;
          margin-bottom: 5px;
          border-radius: 8px;
          &:last-child {
            margin-bottom: 0;
          }
          &:hover {
            cursor: pointer;
          }
          .locker-name {
            display: flex;
            align-items: center;
            .statusImg {
              margin-right: 8px;
              margin-left: 16px;
              width: 8px;
            }
            span {
              font-size: $twelveSize;
              text-align: left;
            }
          }
          .checkbox-lockerId {
            margin-right: 16px;
          }
          img {
            margin-right: 14px;
          }
          &.locker-small {
            height: 39px;
          }
          &.locker-medium {
            height: 78px;
          }
          &.locker-large {
            height: 178px;
          }
          &.locker-semi-large {
            height: 137px;
          }
          &.tiny {
            height: 39px;
          }
          &.locker-state-disabled {
            opacity: 0.45;
            background-color: $border;
            cursor: not-allowed !important;
            pointer-events: none;
            &:hover {
              cursor: not-allowed;
            }
          }
        }
        .active {
          background: $white;
        }
      }
    }
  }
}

.moving-card {
  opacity: 0.5;
  border: 1px solid $main-green;
}
</style>
